
import { createSlice, current } from "@reduxjs/toolkit";
import apiService from "../../api/apiService";

const ActivityLogInitialState = {
  list: {
    isLoading: false,
    data: null,
    error: null,
  }
};

export const activityLogSlice = createSlice({
  name: "activityLog",
  initialState: {
    ...ActivityLogInitialState
  },
  reducers: {
    FetchListRequesting: (state) => {
      state.list.isLoading = true;
      state.list.error = null;
    },
    FetchListSuccess: (state, action) => {
      // No deduplication needed for activity log, just set data
      state.list.isLoading = false;
      state.list.error = null;
      state.list.data = action.payload.data;
    },
    FetchListError: (state, action) => {
      state.list.isLoading = false;
      state.list.error = action.payload;
    },
    FetchListReset: (state) => {
      state.list = ActivityLogInitialState.list;
    },
  }
});

export const fetchActivityLogAPI = (params = {}) => async dispatch => {
  dispatch(FetchListRequesting());
  try {
    const { clientId, objectId, page = 1 } = params;
    const queryParams = new URLSearchParams();
    queryParams.set("page", page);
    if (clientId) queryParams.set("client", clientId);
    if (objectId) queryParams.set("object_id", objectId);
    const response = await apiService.get(`/activity-log/activities/?${queryParams.toString()}`);
    dispatch(FetchListSuccess(response.data));
  } catch (error) {
    dispatch(FetchListError(error.response?.data || error.message));
  }
};

export const {
  FetchListRequesting,
  FetchListSuccess,
  FetchListError,
  FetchListReset
} = activityLogSlice.actions;

export const activityLogReset = FetchListReset;
export const ActivityLogState = (state) => state.activityLog;
export default activityLogSlice.reducer;
